import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import { ROUTES } from '@/enums'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: ROUTES.START,
        component: () => import(/* webpackChunkName: "start" */ '@/views/Start/Start.vue'),
    },
    {
        path: '/orders/:orderCode',
        name: ROUTES.ORDER_DETAILS,
        props: true,
        component: () =>
            import(
                /* webpackChunkName: "order-details" */ '@/views/OrderDetails/OrderDetails.vue'
            ),
    },
    {
        path: '/orders/:orderCode/payments/:paymentId',
        name: ROUTES.ORDER_PAYMENT_STATUS,
        props: true,
        component: () =>
            import(
                /* webpackChunkName: "order-payment-status" */ '@/views/OrderPaymentStatus/OrderPaymentStatus.vue'
            ),
    },
    {
        path: '/orders/:orderCode/shipping/:shippingId',
        name: ROUTES.ORDER_SHIPPING_STATUS,
        props: true,
        component: () =>
            import(
                /* webpackChunkName: "order-shipping-status" */ '@/views/OrderShippingStatus/OrderShippingStatus.vue'
            ),
    },
    {
        path: '/regulamin',
        name: ROUTES.TERMS_OF_USE,
        beforeEnter() {
            window.open(
                'https://docs.google.com/document/d/1tofz6v0oEoNMp7p2OPOXQIeh65isfG1PigvnPXwuOSs/export?format=pdf'
            )

            return false
        },
    },
    {
        path: '/polityka-cookies',
        name: ROUTES.POLICY_COOKIES,
        beforeEnter() {
            window.open('https://grp.umami.pl/polityka-plikow-cookies')

            return false
        },
    },
    {
        path: '/polityka-prywatnosci',
        name: ROUTES.POLICY_PRIVACY,
        beforeEnter() {
            window.open('https://grp.umami.pl/polityka-prywatnosci')

            return false
        },
    },
    {
        path: '*',
        redirect: { name: ROUTES.START },
    },
]

export const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})
